import React, { useState } from 'react';
import { Menu, Button, Drawer } from 'antd';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import './Main.scss';
import { ReactSVG } from 'react-svg';

const MainMenu = ({ user, avatarUrl }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const [drawerOpen, setDrawerOpen] = useState(false);

  const role = user?.role?.toLowerCase();
  let selectedKey = pathname;

  if (selectedKey?.includes('route-plans')) {
    selectedKey = '/route-plans';
  } else if (selectedKey?.includes('/users')) {
    selectedKey = '/users';
  } else if (selectedKey?.includes('routes')) {
    selectedKey = '/routes';
  } else if (selectedKey?.includes('orders') && !selectedKey?.includes('routes')) {
    selectedKey = '/orders';
  } else if (selectedKey?.includes('hubs')) {
    selectedKey = '/hubs';
  } else if (selectedKey?.includes('fleet')) {
    selectedKey = '/fleet';
  } else if (selectedKey?.includes('drivers') && !selectedKey?.includes('routes')) {
    selectedKey = '/drivers';
  } else if (selectedKey?.includes('partners')) {
    selectedKey = '/partners';
  } else if (selectedKey?.includes('scheduler')) {
    selectedKey = '/scheduler';
  }

  const items = [
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/route-plans.svg" />
          <Link to={`/admin/route-plans`}>Route Plan</Link>
        </div>
      ),
      key: '/route-plans',
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/routes.svg" />
          <Link to="/admin/routes">Routes</Link>
        </div>
      ),
      key: '/routes',
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/all_inbox.svg" />
          <Link to="/admin/orders">Orders</Link>
        </div>
      ),
      key: '/orders',
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/all_inbox.svg" />
          <Link to="/admin/hubs">Hubs</Link>
        </div>
      ),
      key: '/hubs',
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/directions_car.svg" />
          <Link to="/admin/fleet">Fleet</Link>
        </div>
      ),
      key: '/fleet',
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/directions_bike.svg" />
          <Link to="/admin/drivers">Drivers</Link>
        </div>
      ),
      key: '/drivers',
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/event_note.svg" />
          <Link to="/admin/scheduler">Scheduler</Link>
        </div>
      ),
      key: '/scheduler',
    },
    {
      label: (
        <div className="MenuItemContent">
          <ReactSVG className="icon" src="/icons/all_inbox.svg" />
          <Link to="/admin/partners">Partners</Link>
        </div>
      ),
      key: '/partners',
    },
    ...(role === 'superadmin'
      ? [
          {
            label: (
              <div className="MenuItemContent">
                <ReactSVG className="icon" src="/icons/supervised_user_circle.svg" />
                <Link to="/admin/users">Users</Link>
              </div>
            ),
            key: '/users',
          },
        ]
      : []),
    // TODO: Settings page not implemented yet
    // {
    //   label: (
    //     <div className="MenuItemContent">
    //       <ReactSVG className="icon" src="/icons/settings.svg" />
    //       <Link to="/admin/settings">Settings</Link>
    //     </div>
    //   ),
    //   key: '/settings',
    // },
  ];

  const drawerItems = [
    { label: 'Route Plan', path: '/admin/route-plans', key: '/route-plans', icon: '/icons/route-plans.svg' },
    { label: 'Routes', path: '/admin/routes', key: '/routes', icon: '/icons/routes.svg' },
    { label: 'Orders', path: '/admin/orders', key: '/orders', icon: '/icons/all_inbox.svg' },
    { label: 'Hubs', path: '/admin/hubs', key: '/hubs', icon: '/icons/all_inbox.svg' },
    { label: 'Fleet', path: '/admin/fleet', key: '/fleet', icon: '/icons/directions_car.svg' },
    { label: 'Drivers', path: '/admin/drivers', key: '/drivers', icon: '/icons/directions_bike.svg' },
    { label: 'Scheduler', path: '/admin/scheduler', key: '/scheduler', icon: '/icons/event_note.svg' },
    { label: 'Partners', path: '/admin/partners', key: '/partners', icon: '/icons/all_inbox.svg' },
    ...(role === 'superadmin'
      ? [{ label: 'Users', path: '/admin/users', key: '/users', icon: '/icons/supervised_user_circle.svg' }]
      : []),
  ];

  const handleDrawerNav = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  return (
    <>
      <Menu className="MainMenu desktop-menu" selectedKeys={[selectedKey]} mode="horizontal" items={items} />

      <Button className="mobile-menu-trigger" type="text" icon={<MenuOutlined />} onClick={() => setDrawerOpen(true)} />

      <Drawer
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={280}
        className="mobile-nav-drawer"
        closeIcon={<CloseOutlined />}
        title={<img src="/logo.svg" alt="logo" style={{ height: 28 }} />}
      >
        {user && (
          <div className="mobile-nav-user">
            <img className="mobile-nav-user-avatar" src={avatarUrl} alt="" />
            <div className="mobile-nav-user-info">
              <div className="mobile-nav-user-name">{user.name}</div>
              <div className="mobile-nav-user-email">{user.email}</div>
            </div>
          </div>
        )}
        <nav className="mobile-nav-list">
          {drawerItems.map((item) => (
            <div
              key={item.key}
              className={`mobile-nav-item ${selectedKey === item.key ? 'active' : ''}`}
              onClick={() => handleDrawerNav(item.path)}
            >
              <ReactSVG className="icon" src={item.icon} />
              <span>{item.label}</span>
            </div>
          ))}
        </nav>
        <div className="mobile-nav-footer">
          <div className="mobile-nav-item" onClick={() => handleDrawerNav('/logout')}>
            <span>Log Out</span>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default MainMenu;
